import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ColumnMode } from '@swimlane/ngx-datatable';
import dayjs from 'dayjs';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';

@Component({
	selector: 'app-notifications-admin',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
	ColumnMode = ColumnMode;

	filterForm: FormGroup;
	notifications: any[] = [];
	notificationTypes: string[] = [];

	loading = false;
	dateRange: any = null;

	selectedType: string | null = null;
	selectedPortal: string | null = null;
	searchUser: string = '';

	constructor(
		private fb: FormBuilder,
		private notificationsSrv: NotificationsService,
	) {
		this.filterForm = this.fb.group({
			type: [null],
			portal: [null],
		});
	}

	ngOnInit(): void {
		this.dateRange = {
			dateStart: dayjs().startOf('week'),
			dateEnd: dayjs().endOf('week'),
		};
		this.loadNotifications();
	}

	dateSelected(event: any): void {
		console.log('dateSelected event:', event);
		this.dateRange = event;
		this.loadNotifications();
	}

	loadNotifications(): void {
		this.loading = true;

		const filters = {
			dateFrom: this.dateRange?.dateStart ? this.dateRange.dateStart.format('YYYY-MM-DD') : undefined,
			dateTo: this.dateRange?.dateEnd ? this.dateRange.dateEnd.format('YYYY-MM-DD') : undefined,
		};

		this.notificationsSrv.getAllNotifications(filters).subscribe({
			next: (data: any) => {
				this.notifications = data?.body ?? [];
				this.loadNotificationTypes();
				this.loading = false;
			},
			error: (err) => {
				console.error('Error cargando notificaciones', err);
				this.notifications = [];
				this.loading = false;
			},
		});
	}

	get filteredNotifications(): any[] {
		const { type, portal } = this.filterForm.getRawValue();

		return this.notifications.filter((n) => {
			const matchesType = !type || n.type === type;
			const matchesPortal = !portal || n.portal === portal;
			const matchesUser = !this.searchUser || (n.user_name?.toLowerCase() ?? '').includes(this.searchUser.toLowerCase());

			return matchesType && matchesPortal && matchesUser;
		});
	}

	clearFilters(): void {
		this.dateRange = null;
		this.filterForm.reset({
			type: null,
			portal: null,
		});
		this.searchUser = '';
		this.loadNotifications();
	}

	getTypeBadgeClass(type: string): string {
		switch (type) {
			case 'lead_assigned':
				return 'bg-primary';
			case 'reminder':
				return 'bg-warning';
			case 'billing':
				return 'bg-danger';
			default:
				return 'bg-secondary';
		}
	}

	loadNotificationTypes(): void {
		const types = this.notifications.map((n) => n.type).filter(Boolean);
		this.notificationTypes = [...new Set(types)]; // únicos
	}

	setType(type: string | null): void {
		this.selectedType = type;
		this.filterForm.patchValue({ type });
	}

	setPortal(portal: string | null): void {
		this.selectedPortal = portal;
		this.filterForm.patchValue({ portal });
	}

	getTypeLabel(type: string): string {
		if (!type) {
			return '';
		}

		return type.replace(/[_-]/g, ' ').replace(/^./, (c) => c.toUpperCase());
	}

	getPortalClass(portal: string | null): string {
		switch (portal) {
			case 'CAL':
				return 'portal-caller';
			case 'CUS':
				return 'portal-customer';
			case 'ADM':
				return 'portal-admin';
			default:
				return '';
		}
	}

	getPortalBadgeClass(portal: string | null): string {
		switch (portal) {
			case 'CAL':
				return 'portal-caller';
			case 'CUS':
				return 'portal-customer';
			case 'ADM':
				return 'portal-admin';
			default:
				return 'portal-default';
		}
	}

	getAvatarIconClass(type: string): string {
		switch (type) {
			case 'lead_created':
				return 'ri-user-fill';
			case 'lead_paid':
				return 'ri-money-dollar-circle-line';
			case 'reschedule_request':
				return 'ri-calendar-check-line';
			case 'revised_lead':
			case 'lead_replaced':
				return 'ri-refresh-line';
			default:
				return 'ri-notification-3-line';
		}
	}

	getPortalLabel(portal: string | null): string {
		switch (portal) {
			case 'CAL':
				return 'Caller';

			case 'CUS':
				return 'Customer';

			case 'ADM':
				return 'Admin';

			default:
				return '-';
		}
	}
}
